// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1dkuH","row":"Node_row__2BRau","label":"Node_label__28ewc","footer":"Node_footer__3KMH_"};